import { message } from 'antd';
import { getScanDate } from '@/components/report/service';
import ActualDetail from '@/Entity/ActualDetail';
import GenerateCondit from '@/models/GenerateCondit';
import moment from 'moment';
import { crudRequest } from '@/services/api';
export default {
  namespace: 'waybillDuration',
  state: {
    search: {
      signDate: moment().add(-1, 'day').format('YYYY-MM-DD'),
    },
    dataList: [],
    page: 1,
    pageSize: 20,
  },
  effects: {
    *getList({ payload }, { call, put, select }) {
      crudRequest('/api/route/waybillDuration/search');
      const waybillDuration = yield select(({ waybillDuration }) => waybillDuration);
      const { search, page, pageSize } = waybillDuration;
      let { dataList } = waybillDuration;
      const {
        waybillNo,
        signDate,
        siteTypeCode,
        originProvinceArea,
        destinationProvinceArea,
        originCenter,
        destinationCenter,
        productType,
      } = search;
      const pages = payload?.page ?? page;

      const offset = pageSize * (pages - 1) || null;
      if (waybillNo) {
        if (`${waybillNo}`.length !== 12) {
          message.warn('运单号长度为12位,请输入正确单号！');
          return;
        }
      }
      if (!signDate) {
        message.warn('签收时间必填，请选择');
        return;
      }
      const actualTable = 'static_actual_time_consume_result'; // 实际表
      const preTable = 'static_actual_time_consume_result_sat';
      const dataSource = window.location.port === '16881' ? preTable : actualTable;
      const gc = new GenerateCondit<ActualDetail>({
        dataSource,
        dimensions: [
          'waybillNo',
          'productType',
          'superiorityProduct',
          'originSite',
          'originCounty',
          'sendDate',
          'destinationSite',
          'destinationCounty',
          'signDate',
          'countyAgingOriginCenter',
          'originProvinceArea',
          'countyAgingDestinationCenter',
          'destinationProvinceArea',
          'deliveryPeriod',
          'trunkLinePeriod',
          'dispatchPeriod',
          'totalPeriod',
          '__time',
        ],
        aggregators: [],
        startDate: moment(signDate).format('YYYY-MM-DD 00:00:00'),
        endDate: moment(signDate).add(1, 'days').format('YYYY-MM-DD 00:00:00'),
        // simpleGranularity: "day",
        queryType: 'scan',
        offset,
        limit: pageSize,
      });
      // 根据类型赋值 siteTypeCode
      let query: {
        waybillNo: string;
        countyAgingOriginCenterCode?: string;
        originProvinceAreaCode?: string;
      } = { waybillNo };
      // let siteCode = (originProvinceArea && originProvinceArea.code) || undefined;
      // if (['900100', '900200'].includes(siteTypeCode) && siteCode) {
      //   query.countyAgingOriginCenterCode = siteCode;
      // } else if (siteCode) {
      //   query.originProvinceAreaCode = siteCode;
      // }
      const entity = new ActualDetail({
        ...query,
        originProvinceAreaCode: originProvinceArea?.code,
        countyAgingOriginCenterCode: originCenter?.code,
        countyAgingDestinationCenterCode: destinationCenter?.code,
        destinationProvinceAreaCode: destinationProvinceArea?.code,
        productType: productType,
      });
      const condit = gc.converCondit(entity);
      const data = yield getScanDate(condit);
      const tempData = data?.map((m, index) => ({
        key: index + offset,
        ...m,
        signDate: moment(m.__time).utc().format('YYYY-MM-DD HH:mm:ss'),
      }));
      if (pages == 1) dataList = [];
      Array.prototype.push.apply(dataList, tempData);
      yield put({ type: 'update', payload: { dataList: [...dataList], page: pages } });
    },
    *exportData({ payload }, { call, put, select }) {
      crudRequest('/api/route/waybillDuration/search');
      const waybillDuration = yield select(({ waybillDuration }) => waybillDuration);
      const { search, page, pageSize } = waybillDuration;
      let { dataList } = waybillDuration;
      const {
        waybillNo,
        signDate,
        siteTypeCode,
        originProvinceArea,
        destinationProvinceArea,
        originCenter,
        destinationCenter,
        productType,
      } = search;
      const pages = payload?.page ?? page;

      const offset = pageSize * (pages - 1) || null;
      if (waybillNo) {
        if (`${waybillNo}`.length !== 12) {
          message.warn('运单号长度为12位,请输入正确单号！');
          return;
        }
      }
      if (!signDate) {
        message.warn('签收时间必填，请选择');
        return;
      }
      const actualTable = 'static_actual_time_consume_result'; // 实际表
      const preTable = 'static_actual_time_consume_result_sat';
      const dataSource = window.location.port === '16881' ? preTable : actualTable;
      const gc = new GenerateCondit<ActualDetail>({
        dataSource,
        dimensions: [
          'waybillNo',
          'productType',
          'superiorityProduct',
          'originSite',
          'originCounty',
          'sendDate',
          'destinationSite',
          'destinationCounty',
          'signDate',
          'countyAgingOriginCenter',
          'originProvinceArea',
          'countyAgingDestinationCenter',
          'destinationProvinceArea',
          'deliveryPeriod',
          'trunkLinePeriod',
          'dispatchPeriod',
          'totalPeriod',
          '__time',
        ],
        aggregators: [],
        startDate: moment(signDate).format('YYYY-MM-DD 00:00:00'),
        endDate: moment(signDate).add(1, 'days').format('YYYY-MM-DD 00:00:00'),
        // simpleGranularity: "day",
        queryType: 'scan',
        offset,
        limit: pageSize,
      });
      // 根据类型赋值 siteTypeCode
      let query: {
        waybillNo: string;
        countyAgingOriginCenterCode?: string;
        originProvinceAreaCode?: string;
      } = { waybillNo };
      let siteCode = (originProvinceArea && originProvinceArea.code) || undefined;
      if (['900100', '900200'].includes(siteTypeCode) && siteCode) {
        query.countyAgingOriginCenterCode = siteCode;
      } else if (siteCode) {
        query.originProvinceAreaCode = siteCode;
      }
      const entity = new ActualDetail({
        ...query,
        countyAgingOriginCenterCode: originCenter?.code,
        countyAgingDestinationCenterCode: destinationCenter?.code,
        destinationProvinceAreaCode: destinationProvinceArea?.code,
        productType: productType,
      });
      const condit = gc.converCondit(entity);
      const data = yield getScanDate(condit);
      const tempData = data?.map((m, index) => ({
        key: index + offset,
        ...m,
        signDate: moment(m.__time).utc().format('YYYY-MM-DD HH:mm:ss'),
      }));
      if (pages == 1) dataList = [];
      Array.prototype.push.apply(dataList, tempData);
      yield put({ type: 'update', payload: { dataList: [...dataList], page: pages } });

      if (dataList.length > 0) {
        yield put({
          type: 'filedownload/waybillDurationExport',
          payload: {
            endDate: moment(search.signDate).add(1, 'days').format('YYYY-MM-DD 00:00:00'),
            startDate: moment(search.signDate).format('YYYY-MM-DD 00:00:00'),
          },
        });
      } else {
        message.warning('没有可以导出的数据');
      }
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    updateSearch(state, { payload }) {
      return { ...state, search: { ...state.search, ...payload } };
    },
  },
};
